<template>
  <div>
    <el-menu style="position: fixed;left: 0;width: 200px;height:100%;top: 0;text-align: left;"
      :default-active="activeName" class="el-menu-vertical-demo" @select="handleSelect" background-color="#3A4856"
      text-color="#fff" active-text-color="#2b85e4" :collapse="isCollapse">
      <el-image
        style="width: 100%;margin-bottom: 20px;"
        src="/static/images/menu_logo.jpg"></el-image>
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location" style="color: #fff;"></i>
          <span>地点库</span>
        </template>
        <el-menu-item index="1-1">
          <template slot="title">地图模式</template>
        </el-menu-item>
        <el-menu-item index="1-2">
          <template slot="title">列表模式</template>
        </el-menu-item>
      </el-submenu>
      <el-menu-item index="2">
        <i class="el-icon-user-solid" style="color: #fff;"></i>
        <span slot="title">团队管理</span>
      </el-menu-item>
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-s-promotion" style="color: #fff;"></i>
          <span>路线管理</span>
        </template>
        <el-menu-item index="3-1">
          <template slot="title">团队路线</template>
        </el-menu-item>
        <el-menu-item index="3-2">
          <template slot="title">路线排单</template>
        </el-menu-item>
      </el-submenu>
<!--      <div class="menu-action" @click="changeCollapse">-->
<!--        <i class="el-icon-s-unfold menu-action-icon" v-if="isCollapse"></i>-->
<!--        <i class="el-icon-s-fold menu-action-icon" v-else></i>-->
<!--      </div>-->
    </el-menu>
    <Common :commentFormState="commentFormState" :memberUpgradeState="memberUpgradeState" :options="options"></Common>
  </div>
</template>

<script>
import store from 'store'
import Common from '@/components/Common.vue'
import { GetUpgradeableLevel } from '../api/member.js'
import { GetTeamDetails } from '../api/team.js'

export default {
  name: 'Menu',
  components: { Common },
  data() {
    return {
      team: {},
      dialogTableVisible: false,
      commentFormState: false,
      memberUpgradeState: false,
      options: [],
      isCollapse: false,
    }
  },
  props: {
    activeName: {
      type: String,
      default: '1'
    }
  },
  mounted() {
    this.team = store.get('team')
    this.getTeamDetails()
  },
  methods: {
    changeCollapse() {
      this.isCollapse = !this.isCollapse
    },
    logout() {
      store.remove('team')
      store.remove('token')
      this.$router.push({ name: 'login' })
    },
    getTeamDetails() {
      GetTeamDetails().then(res => {
        if (res.code === 200) {
          this.team = res.data.info
        }
      })
    },
    handleSelect(e) {
      switch (e) {
        case '1-1':
          this.$router.push({ name: 'index' })
          break
        case '1-2':
          this.$router.push({ name: 'place' })
          break
        case '2':
          this.$router.push({ name: 'personnel' })
          break
        case '3-1':
          this.$router.push({ name: 'route-list' })
          break
        case '3-2':
          this.$router.push({ name: 'plan' })
          break
        case '4-1':
          window.open('/#/member')
          break
        case '4-2':
          this.getVipType()
          break
        case '5':
          break
        case '6':
          window.open('https://www.yuque.com/yancheng-udx5g/iwf8ox/qh5u97')
          break
      }
    },
    getVipType() {
      var that = this
      GetUpgradeableLevel().then(res => {
        if (res.code === 200) {
          that.options = res.data
          that.memberUpgradeState = true
        } else {
          that.$notify({
            title: '错误',
            type: 'error',
            message: res.message,
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.menu-action {
  position: absolute;
  bottom: 20px;
  font-size: 24px;
  color: #fff;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.menu-action-icon {
  padding: 20px;
}

.team-details {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #00BAE0;
  height: 80px;
  width: 200px;
  border-top-left-radius: 5px;
  border-top-right-radius: 10px;
  display: flex;
  flex-direction: row;
  color: #fff;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue